import React, { useState } from 'react';
import { View } from 'react-native';

import RelayTable from 'app/src/elements/Table/RelayTable';
import { Title, Text } from 'app/src/styles';
import { dateShort } from 'app/src/utils/formatting';
import { Link } from 'app/src/utils/routing';

import { PROVIDERS } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'client',
    label: 'Client',
    value: ({ value }) => value.name,
  },
  {
    key: 'emoji',
    label: 'Emoji',
  },
  {
    key: 'providerType',
    label: 'Type',
  },
  {
    key: 'phoneNumber',
    label: 'Phone',
  },
  {
    key: 'startOn',
    label: 'Start Date',
    content: dateShort,
  },
  {
    key: 'endOn',
    label: 'End Date',
    content: dateShort,
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/providers/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const Providers = () => {
  const [refetch, setRefetch] = useState();

  return (
    <View>
      <Title>Providers</Title>

      <Link to="/providers/new">
        <Text>Add Provider</Text>
      </Link>

      <RelayTable
        query={PROVIDERS}
        queryName="providers"
        columns={columns}
        setRefetch={setRefetch}
      />
    </View>
  );
};

export default Providers;
